module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////srnvljjjyy6755tnvvZb88+z12cT67OPnlkvqpm39+fbxxKLonl3338/00rnttokd7fSOAAAAjklEQVR4Xu2TSQoDMQwE0y15mTX5/2uDZhwCY1uHLDfXqaAQfbFvf2MQxTBLJnrJSpKzGczkkjMwEWYrYLkCRLFWHlk7mV5W1VMW1fjzF5H0hTSy8k0742Du5SK9LAehlwufXW/etnDzrsXfBuFcL2RytoWM/ZzLF1PZA6cqr2Qup2Sot8P9FACP7x7L4AmAuwM9uk2WggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_nov.png
// module id = 1693
// module chunks = 1